<template>
  <kez-modal
    :size="size"
    :value="value"
    @input="value => $emit('input', value)">

    <alert-message
      :alert="{
        title: title,
        message: message,
        icon: 'error_outline'
    }" />

    <slot />

    <div class="text-center mt-3 mt-md-4">
      <button
        type="button"
        class="btn btn-danger btn-lg mt-1"
        @click="cancel()">
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-success btn-lg mt-1"
        @click="confirm()">
        Confirmer
      </button>
    </div>
</kez-modal></template>

<script>
import AlertMessage from '@/components/alerts/AlertMessage';
import KezModal from './KezModal';

export default {
  components: {
    AlertMessage,
    KezModal,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: null,
    },
    value: {
      type: Boolean,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
    confirmButtonText: {
      type: String,
      default: 'CONFIRM',
    },
    cancelButtonText: {
      type: String,
      default: 'CLOSE',
    },
  },
  methods: {
    confirm() {
      this.$emit('input', false);
      this.$emit('confirm');
    },
    cancel() {
      this.$emit('input', false);
      this.$emit('cancel');
    },
  },
};
</script>
